export default __webpack_public_path__ + "static/media/chevron_up_arrow.1dbb1129.svg";